//don't add any newlines between the tick marks, otw you'll get a blank item in the bucket of texts
const sentenceText_ptbr = `Meu relógio caiu na água.
A respiração é difícil.
Eu posso ver os anéis de Saturno.
Física e química são difíceis.
Minha conta bancária está negativa.
Nós estamos comendo espaguete.
Os elefantes têm medo de ratos.
Esse é o meu lugar favorito para visitar.
Cuidado com objetos voando baixo.
Por favor, diga sua data de nascimento.
Corremos o risco de fracassar.
Ele é como todos os outros.
O mundo é um palco.
Você está falando comigo?
Sim, você é muito inteligente.
A força está com você.
Você se divertiu?
O espaço é uma alta prioridade.
Você é um exemplo maravilhoso.
Não desperdice o seu tempo.
Não beba demais.
A música é melhor do que parece.
Venha ver o nosso carro novo.
Estou indo para a aula de música.
Em breve vamos voltar para a cidade.
Eu estou vestindo uma jaqueta e uma gravata.
Haverá algum nevoeiro esta noite.
Eu sou alérgico a abelhas e amendoim.
Ele ainda está em nossa equipe.
Meu doce preferido é chocolate.
O rei manda você para a torre.
Somos súditos e devemos obedecer.
Mamãe fez sua blusa de gola alta.
Nós fomos fazer compras no supermercado.
O trabalho deve ser entregue hoje.
O que você vê é o que você recebe.
A loja vai fechar às dez.
Isso é muito ruim.
Esta é uma idéia muito boa.
Nosso número de telefone mudou.
Obrigado pela ajuda.
A biblioteca está fechada hoje.
Maria tinha um coelhinho.
Este relógio é muito caro.
O serviço postal é muito lento.
O outono é a minha estação preferida.
A raposa é um animal muito inteligente.
As crianças estão muito animadas.
O estacionamento está cheio de caminhões.
Minha bicicleta tem um pneu furado.
Não ande depressa demais.
Um pato grasna para pedir comida.
O sol nasce no leste.
Está ventando muito hoje.
Não se preocupe com isso.
Ele estava vestindo um moletom.
Vou encontrá-lo ao meio-dia.
Eu quero segurar sua mão.
As crianças estão brincando do lado de fora.
Você gosta de fazer compras no domingo?
Eu derramei café no tapete.
Não beba essa água.
Meu carro sempre quebra no inverno.
Você gosta de ir acampar?
Os manifestantes bloquearam todo o tráfego.
O discurso de posse foi chato.
Trabalhe duro para chegar ao topo.
Uma boa piada merece boas risadas.
O sindicato vai entrar em greve.
Nunca misture religião e política.
Os ingressos estão muito caros.
Uma imagem vale muitas palavras.
Esta câmera tira boas fotografias.
Parece um barraco.
O cachorro enterrou o osso.
Eu simplesmente não consigo entender isso.
Por favor, siga as orientações.
Um aeroporto é um lugar muito movimentado.
O ônibus estava muito cheio.
Amanhã deve estar ensolarado 
Um médico irá ajudá-lo.
Você deve procurar um dentista.
Você deve marcar uma consulta.
Os jogadores devem conhecer todas as regras.
Você gostaria de vir à minha casa?
Fevereiro tem um dia a mais.
Não se sinta muito mal com isso.
Esta biblioteca tem muitos livros.
Eu gosto de jogar tênis.
É difícil concentrar.
Eu ouço a gravação todos os dias.
Ele está gritando.
A tomada não se encaixa no soquete.
Nós jantamos fora nos finais de semana.
A água foi monitorada diariamente.
Ele assistiu com espanto.
Havia um grande arranhão na mesa.
Os vendedores devem alcançar a sua quota mensal.
Salvar a criança foi um esforço heróico.
O granito é a rocha mais dura de todas.
Temos testemunhas suficientes.
Golfinhos dão saltos altos fora da água.
O sistema de ventilação está quebrado.
Os dinossauros foram extintos há muito tempo.
As ondas altas nos afogarão.
O tesoureiro deve equilibrar suas contas.
Eles assistiram o filme inteiro.`;

export default sentenceText_ptbr;
